<script lang="ts" setup>
import type { Menu } from '~/types/models/menu'

interface Props {
  item: Menu.MenuItem
  childrenWrapperClass?: string
  activeMenuId?: Maybe<number>
}

const props = withDefaults(defineProps<Props>(), {
  childrenWrapperClass: undefined,
  activeMenuId: null,
})
const emit = defineEmits<{
  (e: 'toggle', id: number): void
}>()

const handleClick = () => {
  if (props.item.children.length <= 0) return
  emit('toggle', props.item.id)
}

const isMenuDropdownOpened = computed<boolean>(() => props.activeMenuId === props.item.id)
</script>

<template>
  <li
    itemtype="https://www.schema.org/SiteNavigationElement"
    :class="{ 'header__nav-menu-item--opened': isMenuDropdownOpened }"
    :aria-expanded="isMenuDropdownOpened"
    :aria-haspopup="item.children.length > 0"
  >
    <button
      :id="`element-${item.id}`"
      tabindex="0"
      :data-track-analytics-id="item.analyticsId"
      @click.prevent="handleClick"
    >
      {{ item.name }}
    </button>
    <ul
      v-if="item.children.length > 0"
      :class="childrenWrapperClass"
    >
      <li class="wrapper">
        <ul>
          <template v-for="childrenMenuItem in item.children">
            <Component
              :is="childrenMenuItem.component"
              v-if="childrenMenuItem?.component"
              :key="childrenMenuItem.id"
              :item="childrenMenuItem"
              :children-wrapper-class="childrenWrapperClass"
              :active-menu-id="activeMenuId"
            />
          </template>
        </ul>
      </li>
    </ul>
  </li>
</template>
